var _path, _line;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnBtnEditPen = function SvgIcnBtnEditPen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.11761 12.1349L3.12348 10.3086L7.8328 5.62953L9.67636 7.43866L4.94388 12.1408L3.11761 12.1349ZM10.5277 6.5928L11.3124 5.81316C11.5768 5.5504 11.5782 5.12302 11.3154 4.85857L10.4466 3.98408C10.1838 3.71963 9.75641 3.71826 9.49196 3.98101L8.68412 4.78367L10.5277 6.5928ZM5.62072 13.1599C5.50313 13.2767 5.34395 13.3421 5.17819 13.3415L2.53875 13.3331C2.19357 13.3319 1.91465 13.0512 1.91576 12.706L1.92426 10.0666C1.92479 9.90084 1.99115 9.74209 2.10874 9.62525L8.64617 3.12976C9.38075 2.39988 10.5679 2.4037 11.2978 3.13829L12.1667 4.01278C12.8966 4.74736 12.8927 5.93454 12.1582 6.66441L5.62072 13.1599Z",
    fill: "currentcolor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.79336,
    y1: 12.7594,
    x2: 14.0675,
    y2: 12.7594,
    stroke: "currentcolor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnBtnEditPen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_btn_edit_pen.249f0404.svg";
export { ForwardRef as ReactComponent };